<template>
    <div class="other-tenant-item-content other-tenant-message">
        <span class="other-tenant-title">消息</span>
        <ul class="other-tenant-message-list">
            <li class="other-tenant-title-item" v-for="(item,index) in message" :key="index">
                <img src="../../../../../assets/images/icon_notice.png" width="34" height="20" alt="">
                <span class="other-tenant-message-title">
                    <span @click="openDetail(item)" :title="item.subject">{{item.subject}}</span>
                </span>
                <span @click="openDetail(item)">{{item.updateTime}}</span>
                <span :class="{'message-list-link':!item.link}" @click="downloadFile(item.link)" class="other-tenant-download">下载</span>
            </li>
        </ul>
        <el-dialog
        width="700px"
        title="详情"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false">
        <h1 class="title">{{ detailMain.subject }}</h1>
        <div class="time">
            <span>发布时间：{{ detailMain.updateTime }}</span>
        </div>
        <div class="content" v-html="detailMain.content"></div>
        </el-dialog>
    </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
    data() {
        return {
            message: [],
            dialogVisible: false,
            detailMain: {}
        };
    },
    methods: {
        openDetail(data) {
            this.detailMain = { ...data };
            this.dialogVisible = true;
        },
        dataProcess(data) {
            data.forEach(item => {
                item.updateTime && (item.updateTime = dayjs(item.updateTime).format('YYYY-MM-DD'));
            });
            this.message = data;
        },
        downloadFile(link) {
            if (!link) {
                return;
            }
            window.open(link);
        }
    }
};
</script>
<style lang="less">
.other-tenant-message{
    padding-right: 10px!important;
    .other-tenant-message-list{
        height: 82px;
        overflow: auto;
        padding-right: 10px;
    }
    .message-list-link{
        visibility: hidden;
    }
    .other-tenant-title-item{
        margin-bottom: 11px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: 'PingFangSC-Regular',sans-serif;
        font-size: 12px;
        line-height: 12px;
        color: #333333;
        font-weight: 400;
        >span{
            display: inline-block;
            cursor: pointer;
        }
    }
    .other-tenant-message-title{
        flex: 1;
        margin-left: 6px;
        >span {
            display: inline-block;
            width: 60px;
            overflow:hidden;
            white-space:nowrap;
            text-overflow:ellipsis;
        }
    }
    .other-tenant-download{
        margin-left: 20px;
        color: #2b83fd;
    }
    .el-dialog__body {
        padding: 20px;
        min-height: 380px;
        max-height: 480px;
        overflow-y: auto;
        box-sizing: border-box;
        .title {
            font-size: 18px;
            color: #252626;
            margin-top: 0;
            margin-bottom: 11px;
            text-align: center;
        }
        .time {
            font-size: 12px;
            color: #898C8C;
            margin-bottom: 20px;
            text-align: center;
        }
        .content {
            font-size: 14px;
            line-height: 26px;
        }
    }
}
</style>